// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Q05C","header":"MergedInvoice_header__2QXBs"};